import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MortgageRatesByState from "@/pages/MortgageRatesByState";

export const Route = createFileRoute("/mortgage-rates/$state")({
  head: ({ params }) => seoHead(`/mortgage-rates/${params.state}`),
  component: MortgageRatesByState,
});
